// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__yrhJy","notes":"Notes_notes__3KGf2","note":"Notes_note__1szfO","markdown":"Notes_markdown__3-kA1"};